import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUserAuthorization from './store/user-authorization.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserAuthorizationEffects } from './store/user-authorization.effects';
import { UserAuthorizationContainerComponent } from './user-authorization-container/user-authorization-container.component';
import { UserAuthorizationComponent } from './user-authorization/user-authorization.component';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { UserAuthorizationsRoute } from './user-authorization.route';
import { UpdateMultipleAuthorizationsComponent } from './update-multiple-authorizations/update-multiple-authorizations.component';

@NgModule({
    declarations: [
        UserAuthorizationContainerComponent,
        UserAuthorizationComponent,
        UpdateMultipleAuthorizationsComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(
            fromUserAuthorization.userAuthorizationsFeatureKey,
            fromUserAuthorization.reducer
        ),
        EffectsModule.forFeature([UserAuthorizationEffects]),
        UIRouterModule.forChild({
            states: [UserAuthorizationsRoute]
        })
    ]
})
export class UserAuthorizationsModule {}
